<template>
  <v-dialog v-model="openModal" @click:outside="closeRecapModal" width="75vw">
    <v-card class="modal-content">
      <div id="modal-left" class="modal-left fade">
        <div class="modal-left-content">
          <span class="modal-title">
            {{ $t('message.banners.recap.recapModal.title_one') }}
          </span>
          <div>
            <v-img :src="recapSvg" class="recap-modal-svg" />
          </div>
          <span class="modal-title modal-title-two">
            {{ $t('message.banners.recap.recapModal.title_two') }}
          </span>
          <span
            class="modal-description"
            v-html="$t('message.banners.recap.recapModal.description')"
          ></span>
          <div class="qr-code-container">
            <qrcode-vue
              :value="linkToRedirect"
              :size="200"
              level="L"
              bgColor="#FFFFFF"
              fgColor="#000000"
              renderAs="svg"
            ></qrcode-vue>
          </div>
          <span
            class="modal-description"
            v-html="$t('message.banners.recap.recapModal.instruction')"
          ></span>
        </div>
      </div>
      <div class="modal-right celebration-background">
        <div class="pa-4">
          <v-icon color="white" size="20px" @click="closeRecapModal"
            >mdi-close</v-icon
          >
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
import QrcodeVue from 'qrcode.vue'
import { ENV_CONFIG } from '@/config/envs'
import { mapState } from 'vuex'

export default {
  name: 'RecapModal',
  components: { QrcodeVue },
  data() {
    return {
      openModal: null,
      recapSvg: null,
    }
  },
  props: {
    openRecapModal: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState('user', {
      organizationId: (state) => state.userAllInfo?.organization_id,
    }),
    locale() {
      return this.$i18next.resolvedLanguage
    },
    linkToRedirect() {
      let linkToRedirect = `https://retrospectiva.pandavideo.com.br/${this.organizationId}`
      if (ENV_CONFIG !== 'production') {
        linkToRedirect = `https://retrospectiva-staging.pandavideo.com.br/${this.organizationId}`
      }
      return linkToRedirect
    },
  },
  watch: {
    openRecapModal(val) {
      this.openModal = val
      setTimeout(() => {
        const div_left = document.querySelectorAll('.modal-left')
        div_left.forEach((div) => {
          div.classList.add('show')
        })
      }, 50)
    },
    '$i18next.resolvedLanguage': {
      handler(val) {
        this.recapSvg = require(`@/assets/recap/recapModal/modalRecapSvg2024-${val}.svg`)
      },
      deep: true,
    },
  },
  created() {
    this.recapSvg = require(`@/assets/recap/recapModal/modalRecapSvg2024-${this.locale}.svg`)
  },
  methods: {
    closeRecapModal() {
      this.$emit('closeRecapModal')
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep.v-dialog__content.v-dialog__content--active {
  .v-dialog.v-dialog--active {
    max-height: fit-content !important;
    border: unset !important;
  }
}

.modal-content {
  display: flex;
  flex-direction: row;
  height: 84vh;
  background: linear-gradient(to right, #070f4b 50%, #000f75 100%);
}

.modal-left-content {
  display: flex;
  flex-direction: column;
  justify-content: center !important;
}
.modal-left {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  background: left 0% bottom 715% / 13% 95%
      url('../../assets/recap/recapModal/modalRecapSvg.svg') repeat-y,
    linear-gradient(to right, #070f4b 50%, #000f75 100%);
}

.modal-right {
  flex: 1;
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  background-image: url('../../assets/recap/recapModal/celebrationBackground.png');
  background-size: cover;
  background-position: center;
  background-color: #040a2f;
  max-width: 44%;
}

.modal-description {
  font-size: 2rem;
  line-height: 1.5;
  text-align: center;
  color: #ffffff;
}

.recap-modal-svg {
  width: 100%;
  max-width: 300px;
  height: auto;
  justify-self: center;
}

.modal-title {
  font-family: Rubik;
  font-size: 3rem;
  font-weight: 500;
  line-height: 1.2;
  text-align: center;
  color: #ffffff;
  margin: 10px 0;
}

.modal-title-two {
  margin-bottom: 40px;
}

.fade {
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.5s ease-in-out, visibility 0.5s ease-in-out;
}

.fade.show {
  opacity: 1;
  visibility: visible;
}

.qr-code-container {
  margin-top: 20px;
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
}

@media screen and (max-width: 768px) {
  .modal-content {
    flex-direction: column;
    height: auto;
  }

  .modal-right {
    width: 100%;
    display: none;
  }

  .modal-left-content {
    scale: 1 !important;
    padding: 15px;
  }

  .modal-title {
    font-size: 1.5rem;
  }

  .modal-description {
    font-size: 1rem;
  }

  .recap-modal-svg {
    max-width: 200px;
  }
}

@media screen and (height > 1100px) {
  .modal-left-content {
    scale: 1.2;
  }
}
@media screen and (height < 900px) {
  .modal-left-content {
    scale: 0.8;
  }
}
@media screen and (height < 650px) {
  .modal-left-content {
    scale: 0.6;
  }
}
</style>
